import MainLanding from './MainLanding';
import HowItWorks from './HowItWorks';
import PlansAndPricing from './PlansAndPricing';
import PoweredBy from './PowerdBy';
import Founders from './Founders';
import AboutUs from './AboutUs';
import { isLive, getAt99 } from '../../Utils/Utilities';
import { Button } from '../../Components/UI/button';
import { useEffect, useState } from 'react';
import SahiFooter from './SahiFooter';
import OfferCard from './OfferCard';
import OffersCard from './OffersCard';
import PopupQuestions from './PopupQuestions';
import Features from './Features';
import FeaturesCompact from './FeaturesCompact';
import SahiPricingFooter from './SahiPricingFooter';
import OffersCardGray from './FlashOfferCard';
import FlashOfferCard from './FlashOfferCard';
import FeaturesScrollable from './FeaturesScrollable';
import { getAuthData } from '../../Utils/AuthUtils';
import { useSelector } from 'react-redux';
import FloatingFeedbackButton from '../Ticket/FloatingTktBtn';

// Main App Component
const IndexPage = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [showOffer, setShowOffer] = useState(false);
  const [redirectChecked, setRedirectChecked] = useState(false);
  const authData = getAuthData();
  const agencyData = useSelector((state) => state.agencyData.data);

  const isMobileApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
    const isMobile = mobileRegex.test(userAgent.toLowerCase());

    if (!isMobile) return false;

    const isBrowser = /Chrome|Firefox|Safari|Opera|Edge|Samsung|UC Browser|MIUI|Viber|WeChat/i.test(userAgent);

    const isWebViewGold = userAgent.includes('WebViewGold') || userAgent.includes('webviewgold');

    const isStandalone = window.navigator.standalone === true;
    const isWebAppiOS = window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches;
    const isWebAppAndroid = userAgent.includes('wv') || (userAgent.includes('WebView') && !isBrowser);
    const isCordovaApp = typeof window.cordova !== 'undefined';
    const isReactNativeWebView = userAgent.includes('RN');

    const isWebViewGoldApp = typeof window.WebViewGoldCallback !== 'undefined' || typeof window.sahiCRMApp !== 'undefined';

    return isWebViewGold || isStandalone || isWebAppiOS || isWebAppAndroid || isCordovaApp || isReactNativeWebView || isWebViewGoldApp;
  };

  useEffect(() => {
    document.title = "SahiClub";
    if (!redirectChecked) {
      setIsAuthenticated(!!authData);
      setShowOffer((agencyData?.SubTypeID == 1) && (agencyData?.SubTillDT == (null || undefined)) && (agencyData?.LastUpgdDT == (null || undefined)) && (agencyData?.FirstSubDT == (null || undefined)));

      if (!authData && isMobileApp()) {
        window.location.href = 'https://sahicrm.com/AppIndex';
      }

      setRedirectChecked(true);
    } else {
      setIsAuthenticated(!!authData);
    }
  }, [authData, agencyData, redirectChecked]);

  useEffect(() => {
    if (isAuthenticated && redirectChecked) {
      scrollToSection('pkgAndPricing');
    }
  }, [isAuthenticated, redirectChecked]);

  const scrollToSection = (sectionID) => {
    const element = document.getElementById(sectionID);
    if (!element) return;
    setMobileMenuOpen(false);

    setTimeout(() => {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (sectionID === 'mainLanding') {
        const observer = new IntersectionObserver((entries, observer) => {
          if (entries[0].isIntersecting) {
            const input = document.getElementById('loginDialog');
            if (input) {
              const length = input.value.length;
              input.focus();
              input.setSelectionRange(length, length);
            }
            observer.disconnect();
          }
        }, { threshold: 1.0 });
        observer.observe(element);
      }
    }, 500);
  };

  return (
    <div className="min-h-screen scroll-ml-4">
      <header className={`py-0 px-0 sticky top-0 z-50 ${mobileMenuOpen ? 'bg-sahi-white' : ''}`}>
        <div className="flex justify-between items-center p-4 px-4 md:px-20 bg-white/100 md:bg-white/50 shadow-lg md:shadow-none md:backdrop-blur-md border-0 md:border-b-2 w-full mx-0 md:mx-auto rounded-none md:rounded-none">
          <div className="w-34 md:w-40 h-8 md:h-10 flex items-center justify-center rounded">
            <img src={
              isLive() ? "/Web/assets/Images/SahiLogo.png" : "/assets/Images/SahiLogo.png"
            }
              alt="SahiClub Logo"
              className="max-h-full max-w-full object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex gap-4  lg:gap-6 items-center">
            <button
              onClick={() => scrollToSection('features')}
              className="text-muted-foreground hover:text-sahi-green transition-colors text-sm lg:text-base cursor-pointer"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-muted-foreground hover:text-sahi-green transition-colors text-sm lg:text-base cursor-pointer"
            >
              About Us
            </button>
            {!isAuthenticated && (
              <>
                <button
                  onClick={() => scrollToSection('mainLanding')}
                  className="text-muted-foreground hover:text-sahi-green transition-colors text-sm lg:text-base"
                >
                  Login
                </button>

              </>
            )}
            <Button
              onClick={() => {
                if (isAuthenticated) {
                  scrollToSection('pkgAndPricing')
                } else {
                  scrollToSection('mainLanding')
                }
              }}
              className="bg-sahi-green px-4 lg:px-6 py-2 transition-colors text-sm lg:text-base"
            >
              Start Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-muted-foreground"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="md:hidden pl-3 pr-3 mt-4 pb-4 flex flex-col gap-3 bg-white shadow-[0_20px_25px_-5px_rgba(0,0,0,0.1),0_8px_10px_-6px_rgba(0,0,0,0.1)] border-b-2 border-gray-100">
            <button
              onClick={() => {
                scrollToSection('features');
                setMobileMenuOpen(false);
              }}
              className="text-muted-foreground hover:text-sahi-green transition-colors py-2 text-left"
            >
              Features
            </button>
            <button
              onClick={() => {
                scrollToSection('about');
                setMobileMenuOpen(false);
              }}
              className="text-muted-foreground hover:text-sahi-green transition-colors py-2 text-left"
            >
              About Us
            </button>
            {!isAuthenticated && (
              <>
                <button
                  onClick={() => scrollToSection('mainLanding')}
                  className="text-muted-foreground hover:text-sahi-green transition-colors py-2 text-left"
                >
                  Login
                </button>

              </>
            )}
            <Button
              onClick={() => {
                setMobileMenuOpen(false);
                if (isAuthenticated) {
                  scrollToSection('pkgAndPricing')
                } else {
                  scrollToSection('mainLanding')
                }
              }}
              className="bg-sahi-green px-6 py-2 transition-colors w-full mt-2"
            >
              Start Now
            </Button>
          </nav>
        )}
      </header>

      {/* Hero Section */}
      <div id="mainLanding" className="scroll-mt-[600px] md:scroll-mt-[108px]">
        <MainLanding isAuthenticated={isAuthenticated} />
      </div>

      {
        getAt99 && isAuthenticated &&
        <div className='md:hidden'>
          <FlashOfferCard />
        </div>
      }

      {/* <div>
        <PopupQuestions />
      </div> */}

      <div id="features" className="md:scroll-m-0">
        <FeaturesScrollable isAuthenticated={isAuthenticated} />
      </div>

      <div id="features" className="md:hidden">
        <FeaturesCompact />
      </div>

      {/* Pricing */}
      {/* <div id="pkgAndPricing" className="scroll-mt-2 md:scroll-mt-6">
        <PlansAndPricing isAuthenticated={isAuthenticated} />
      </div> */}

      {/* Powered By */}
      {/* <PoweredBy /> */}

      {/* About Us */}
      <div id="about" className='scroll-mt-2 md:scroll-mt-20'>
        <AboutUs />
      </div>

      {/*
      <div id="founders">
        <Founders />
      </div> */}

      {
        getAt99 && isAuthenticated &&
        <SahiPricingFooter />
      }

      {/* Footer */}
      <div id="footer">
        <SahiFooter />
      </div>

      {isAuthenticated && <FloatingFeedbackButton />}
    </div >
  );
};

export default IndexPage;